/* VENIFRESH — theme interactions (vanilla JS, no dependencies) */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Header blur on scroll ---- */
  var header = document.querySelector(".site-header");
  function onScroll() {
    if (header) header.classList.toggle("scrolled", window.scrollY > 24);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---- Mobile nav ---- */
  var burger = document.querySelector(".burger");
  var mnav = document.querySelector(".mobile-nav");
  if (burger && mnav) {
    burger.addEventListener("click", function () {
      var open = mnav.classList.toggle("open");
      burger.setAttribute("aria-expanded", open);
      document.body.style.overflow = open ? "hidden" : "";
    });
    mnav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mnav.classList.remove("open");
        burger.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
      });
    });
  }

  /* ---- Scroll reveal ---- */
  var reveal = document.querySelectorAll("[data-reveal]");
  if (reduce || !("IntersectionObserver" in window)) {
    reveal.forEach(function (el) { el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    reveal.forEach(function (el) { io.observe(el); });
  }

  /* ---- Light parallax on floating visuals ---- */
  if (!reduce) {
    var floats = document.querySelectorAll("[data-parallax]");
    window.addEventListener("scroll", function () {
      var y = window.scrollY;
      floats.forEach(function (el) {
        var speed = parseFloat(el.getAttribute("data-parallax")) || 0.05;
        el.style.transform = "translateY(" + (y * speed) + "px)";
      });
    }, { passive: true });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll(".faq-q").forEach(function (q) {
    q.addEventListener("click", function () {
      var item = q.closest(".faq");
      var a = item.querySelector(".faq-a");
      var open = item.classList.toggle("open");
      q.setAttribute("aria-expanded", open);
      a.style.maxHeight = open ? a.scrollHeight + "px" : 0;
    });
  });

  /* ---- Ripple on buttons ---- */
  document.querySelectorAll(".btn--primary").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      if (reduce) return;
      var r = document.createElement("span");
      r.className = "ripple";
      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      r.style.width = r.style.height = size + "px";
      r.style.left = (e.clientX - rect.left - size / 2) + "px";
      r.style.top = (e.clientY - rect.top - size / 2) + "px";
      btn.appendChild(r);
      setTimeout(function () { r.remove(); }, 600);
    });
  });

  /* ---- Product gallery thumbs ---- */
  var mainImg = document.querySelector("[data-main-img]");
  document.querySelectorAll("[data-thumb]").forEach(function (t) {
    t.addEventListener("click", function () {
      var src = t.getAttribute("data-src");
      var alt = t.getAttribute("data-alt") || "";
      if (mainImg && src) { mainImg.src = src; mainImg.alt = alt; }
      document.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("active"); });
      t.classList.add("active");
    });
  });

  /* ---- Colour swatches ---- */
  document.querySelectorAll("[data-swatch]").forEach(function (s) {
    s.addEventListener("click", function () {
      document.querySelectorAll("[data-swatch]").forEach(function (x) { x.setAttribute("aria-checked", "false"); });
      s.setAttribute("aria-checked", "true");
      var label = document.querySelector("[data-swatch-label]");
      if (label) label.textContent = s.getAttribute("data-name") || "";
      var input = document.querySelector("[name='id']");
      if (input && s.getAttribute("data-variant")) input.value = s.getAttribute("data-variant");
    });
  });

  /* ---- Quantity ---- */
  document.querySelectorAll("[data-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = parseInt(input.value, 10) || 1;
        v += b.getAttribute("data-step") === "up" ? 1 : -1;
        input.value = Math.max(1, v);
      });
    });
  });

  /* ---- Sticky Add to Cart (product page) ---- */
  var sticky = document.querySelector(".sticky-atc");
  var mainCta = document.querySelector("[data-main-cta]");
  if (sticky && mainCta && "IntersectionObserver" in window) {
    var sObs = new IntersectionObserver(function (entries) {
      sticky.classList.toggle("show", !entries[0].isIntersecting);
    }, { threshold: 0 });
    sObs.observe(mainCta);
  }

  /* ---- Countdown (optional urgency) ---- */
  var cd = document.querySelector("[data-countdown]");
  if (cd) {
    var end = Date.now() + (parseInt(cd.getAttribute("data-countdown"), 10) || 3600) * 1000;
    setInterval(function () {
      var d = Math.max(0, end - Date.now());
      var h = String(Math.floor(d / 3.6e6)).padStart(2, "0");
      var m = String(Math.floor((d % 3.6e6) / 6e4)).padStart(2, "0");
      var s = String(Math.floor((d % 6e4) / 1000)).padStart(2, "0");
      cd.textContent = h + ":" + m + ":" + s;
    }, 1000);
  }
})();
